import { useState, useCallback } from "react";
import { API_CONFIG } from "../config/apiConfig";
import { apiClient } from "../utils/apiClient";

interface ApiResponse {
  success?: boolean;
  data?: any[];
  error?: string;
}

interface ExceptionItem {
  inventoryItemId: string;
  itemNumber: string;
  mfgPartNumber: string;
  description: string;
}

export const useExceptionItemList = () => {
  const [data, setData] = useState<ExceptionItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchExceptionItems = useCallback(async (tosite: string, fromsite?: string, searchTerm?: string, enableItemSearch?: boolean) => {
    if (!tosite || !fromsite) {
      setData([]);
      setError(null);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const { data: response } = await apiClient.get<ApiResponse>(
        API_CONFIG.ENDPOINTS.GET_EXCEPTION_ITEM_LIST,
        {
          params: {
            tosite: String(tosite || '').trim(),
            fromsite: String(fromsite || '').trim(),
            searchTerm: searchTerm ? String(searchTerm).trim() : undefined,
            enableItemSearch: enableItemSearch || false,
          },
        }
      );

      const itemData = Array.isArray(response) ? response : response.data;

      if (Array.isArray(itemData)) {
        setData(itemData);
      } else {
        console.error("Invalid response format:", response);
        setData([]);
      }
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.message;

      setError(errorMessage);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    data,
    isLoading,
    error,
    fetchExceptionItems
  };
};